module.exports = __webpack_public_path__ + "static/media/Dream_mobile_on_SE_EN.921becb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dream_mobile_on_SE_EN.png
// module id = 555
// module chunks = 0